import { useEffect, useRef } from 'react';
import { bridge } from 'shared/src/utils';
import { getGoodsListScreen } from '../utils/getGoodsListScreen';

export const useLogViewGoodsList = (params: {
  type: string;
  totalCount: number | undefined;
  landingFrom: string | undefined;
}) => {
  const hasLoggedRef = useRef(false);

  useEffect(() => {
    if (hasLoggedRef.current) return;
    if (params.totalCount == null) return;
    hasLoggedRef.current = true;
    const screenName = getGoodsListScreen(params.type);

    bridge.logAnalyticsEvent({
      name: `VIEW_${screenName}`,
      analytics: {
        SCREEN: screenName,
        ITEM_COUNT: params.totalCount,
        LANDING_FROM: params.landingFrom,
      },
    });
  }, [params.type, params.totalCount, params.landingFrom]);
};
